export default __webpack_public_path__ + "static/BergenMono-Regular-9f208b02b7691fe692136a37eec3742c.eot";